import { Button } from 'app/components/design-system-components'
import {
  RENTBOND_LEARN_MORE_PARAM,
  rentbondURLWithParams,
} from 'app/Integrations/components/RentBond/config'
import { RENTBOND_DASHBOARD_LEARN_MORE_LINK } from 'app/utils/google-tag-manager/helpers'
import { useGTMTracking } from 'app/utils/hooks/useGTMTracking'

function RentbondLink({ textInLink = 'learn more' }) {
  const RENTBOND_URL = rentbondURLWithParams(RENTBOND_LEARN_MORE_PARAM)
  const {
    trackingProps: { className: trackingClassName, onClick },
  } = useGTMTracking(RENTBOND_DASHBOARD_LEARN_MORE_LINK, RENTBOND_URL)

  return (
    <Button variant="linkBlue" className={trackingClassName} onClick={onClick}>
      {textInLink}
    </Button>
  )
}

export default RentbondLink
